import validateEmail from "@core/utils/validateEmail";
import type { SearchSelectOption } from "@ui-kit/SearchSelect";

// Without an SSO connector the directory search finds nobody, so a valid typed email is offered as an option itself.
export const withTypedEmail = (query: string, options: SearchSelectOption[]): SearchSelectOption[] => {
	const email = query.trim();
	if (!validateEmail(email)) return options;
	if (options.some((option) => String(option.value).toLowerCase() === email.toLowerCase())) return options;
	return [{ value: email, label: email }, ...options];
};
